"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var analytics = require("./de/analytics.json");
var booking = require("./de/booking.json");
var common = require("./de/common.json");
var countries = require("./de/countries.json");
var enduser = require("./de/enduser.json");
var landlord = require("./de/landlord.json");
var priceCalculator = require("./de/priceCalculator.json");
var tapnpark = require("./de/tapnpark.json");
var tenant = require("./de/tenant.json");
var bookingClient = require("./de/bookingClient.json");
var screen = require("./de/screen.json");
exports.Messages = {
    common: common.common,
    enduser: enduser.enduser,
    tenant: tenant.tenant,
    countries: countries.countries,
    tapnpark: tapnpark.tapnpark,
    landlord: landlord.landlord,
    booking: booking.booking,
    analytics: analytics.analytics,
    priceCalculator: priceCalculator.priceCalculator,
    bookingClient: bookingClient.bookingClient,
    screen: screen.screen
};
